var exports = {
  "V0": "miniHeaderInner__PNUGO_",
  "DD": "title__rbH5Fa",
  "ai": "number__psmPBx",
  "yu": "metadata__jEOHXh",
  "UH": "stateLabel__9bt2H7",
  "sb": "navigationDivider__r4fnNP",
  "o1": "actions__tWsgi0",
};

module.exports = exports;
